import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
// eslint-disable-next-line import/no-duplicates
import { differenceInDays, format } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import deLocale from 'date-fns/locale/de';

import { getRevenueNextRepaymentDate } from '../../../../multiLoanDashboard/accountsSelector';

import DashboardCTA from '../../../../multiLoanDashboard/dashboardComponents/DashboardCTA/DashboardCTA';
import DateInIcon from '../../../../multiLoanDashboard/dashboardComponents/futureRepayment/DateInIcon';

import messages from './DashboardActions.messages';

const mapStateToProps = (state) => ({
    repaymentDate: getRevenueNextRepaymentDate(state),
    locale: state.siteContext.locale
});

const FutureRepayments = ({ repaymentDate, locale, className }) => {
    const newRepaymentDate = new Date(repaymentDate);
    const daysToRepayment = differenceInDays(newRepaymentDate, new Date());

    let dateFnsLocal = 'uk';
    if (locale === 'de-DE') {
        dateFnsLocal = deLocale;
    }

    const month = format(newRepaymentDate, 'MMM', { locale: dateFnsLocal });
    const date = format(newRepaymentDate, 'D');

    return (
        <DashboardCTA
            icon={<DateInIcon month={month} date={date} />}
            data-testid="rbl-future-repayments"
            className={className}
            title={<FormattedMessage {...messages.futureRepaymentTitle} />}
            description={
                <FormattedMessage
                    {...messages.futureRepayment}
                    values={{
                        timeToRepayment: <strong>{daysToRepayment}</strong>
                    }}
                />
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(injectIntl(FutureRepayments));
